<div class="periodo-select relative">
  <button
    type="button"
    (click)="toggleDropdown()"
    [disabled]="disabled"
    class="flex min-h-[3.25rem] w-full max-w-full items-center space-x-2 overflow-hidden rounded-lg border border-gray-300 bg-white px-3 py-2 text-left transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white dark:border-gray-600 dark:bg-gray-800 dark:hover:bg-gray-700 dark:disabled:hover:bg-gray-800">
    <div class="min-w-0 flex-1 overflow-hidden text-left">
      <div class="flex min-w-0 items-center space-x-2">
        <span class="block overflow-hidden whitespace-nowrap text-clip text-sm font-semibold text-gray-900 dark:text-gray-100">
          {{ selectedOption?.descricao || emptyLabel }}
        </span>
        <lucide-icon *ngIf="selectedOption && isPeriodoFechado(selectedOption)" name="lock" class="h-4 w-4 text-red-600 dark:text-red-400"></lucide-icon>
        <lucide-icon *ngIf="selectedOption && !isPeriodoFechado(selectedOption)" name="lock-open" class="h-4 w-4 text-green-600 dark:text-green-400"></lucide-icon>
      </div>
      <div *ngIf="getSupportingText(selectedOption)" class="overflow-hidden whitespace-nowrap text-clip text-xs text-gray-500 dark:text-gray-400">
        {{ getSupportingText(selectedOption) }}
      </div>
    </div>
    <button
      *ngIf="clearable && selectedOption && !disabled"
      type="button"
      (click)="clearSelection($event)"
      class="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-gray-100"
      aria-label="Limpar período selecionado">
      <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
    </button>
    <lucide-icon name="chevron-down" class="h-4 w-4 shrink-0 text-gray-600 dark:text-gray-300"></lucide-icon>
  </button>

  <div
    *ngIf="dropdownAberto"
    class="absolute right-0 z-50 mt-0.5 rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
    [ngClass]="dropdownWidthClass">
    <div *ngIf="!options.length" class="px-4 py-3 text-sm text-gray-500 dark:text-gray-400">
      {{ noResultsLabel }}
    </div>

    <button
      *ngFor="let option of options"
      type="button"
      (click)="onSelectionChange(option.id)"
      class="block w-full cursor-pointer border-b border-gray-100 px-4 py-3 text-left transition-colors hover:bg-gray-50 last:border-b-0 dark:border-gray-700 dark:hover:bg-gray-700"
      [ngClass]="selectedId === option.id ? 'bg-gray-50 dark:bg-gray-700/50' : ''">
      <div class="flex items-center space-x-2">
        <div class="min-w-0 flex-1 overflow-hidden">
          <div class="flex min-w-0 items-center space-x-2">
            <div class="overflow-hidden whitespace-nowrap text-clip text-sm font-semibold text-gray-900 dark:text-gray-100">{{ option.descricao }}</div>
            <lucide-icon *ngIf="isPeriodoFechado(option)" name="lock" class="h-4 w-4 flex-shrink-0 text-red-600 dark:text-red-400"></lucide-icon>
            <lucide-icon *ngIf="!isPeriodoFechado(option)" name="lock-open" class="h-4 w-4 flex-shrink-0 text-green-600 dark:text-green-400"></lucide-icon>
          </div>
          <div *ngIf="getSupportingText(option)" class="overflow-hidden whitespace-nowrap text-clip text-xs text-gray-500 dark:text-gray-400">
            {{ getSupportingText(option) }}
          </div>
        </div>
      </div>
    </button>
  </div>
</div>